import { da } from "date-fns/locale";
import { Delete } from "lucide-react";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import UseAxiosPrivate from "../hooks/useAxiosPrivate";
import axios, { axiosPrivate } from "../utils/axios";
import { Trash2 } from 'lucide-react';
import useFetchUpgraded from "../hooks/useFetchUpgraded";

const ScheduleTemplatePopup = ({ isTempOpen, onClose,schedList,setSchedList,schedulelist,setScheduleList }) => {
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");

    const [startDateTime, setStartDateTime] = useState("")
    const [endDateTime, setEndDateTime] = useState("")

    const [scheduleType, setScheduleType] = useState("non_recurring")
    const [recurring_type, setRecurringType] = useState("")
    const [days, setDays] = useState("")

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [showMenu, setShowMenu] = useState(false);

    const axiosprivate = UseAxiosPrivate();

    const [templateData,setTemplateData]=useState([]);

    const fetchDataUpgraded = useFetchUpgraded();


    const fetchScheduleTimeTeamplates=async()=>{
        try{
            // const res = await axiosprivate.get(`${process.env.REACT_APP_API_URL}/contactcentre/shedule_time_template/`)
            const res = await fetchDataUpgraded({
                url: `${process.env.REACT_APP_API_URL}/contactcentre/shedule_time_template/`,
                method: "GET",
                params:{}
            })
            
            if(res.status==200){
                setScheduleList(res.data)
                // alert(res.data)
            }
        }catch(error){
            Swal.fire(
                'Warning!',
                `${error.response.data?.error || 'Something Went wrong. Try Again.'}`,
                'warning'
            );
        }
    }

    const handleDelete = async (index, id) => {
      
        Swal.fire({
            title: "Are you sure to Delete ?",
            text: "This Schedule will be deleted from your schedule list",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Delete",
        }).then(async (result) => {
            if (result.isConfirmed) {
            if (id != null) {
                let config = {
                headers: { "Content-Type": "application/json" },
                data: {
                    "schedule_id": id,
                }
                };

                await axios
                .delete(
                    process.env.REACT_APP_API_URL + "/contactcentre/delete-schedule/",
                    config
                )
                .then((res) => {
                    Swal.fire(
                    'Deleted!',
                    'Customer has been deleted.',
                    'success'
                    );
                })
                }

                setTemplateData(prev =>
                    prev.filter((_, i) => i !== index)
                );
                
            
            }
        })
    };

    useEffect(()=>{
        // fetchScheduleTimeTeamplates();
    },[])

    const handleScheduleType = (event) => {
        setScheduleType(event.target.value)
        setRecurringType('')
        setStartDateTime('');
        setEndDateTime('');
    }

    const handleRecurringMode = (event) => {
        setDays("")
        setRecurringType(event.target.value)
        if (event.target.value === "week_days") {
            setDays("Week_days")
        } else {
            console.log("Choose a day")
        }
    }

    const handleDays = (event) => {
        setDays(event.target.value)
    }

    if (!isTempOpen) return null;

    const isSameDateTime = (startDate, startTime, endDate, endTime) => {
        if (scheduleType === "non_recurring") {
            if (!startDate || !startTime || !endDate || !endTime) {
                return { valid: false, message: "All date and time fields are required" };
            }

            const start = new Date(`${startDate}T${startTime}`);
            const end = new Date(`${endDate}T${endTime}`);

            if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                return { valid: false, message: "Invalid date or time format" };
            }

            if (end.getTime() < start.getTime()) {
                return { valid: false, message: "End time should be greater than start time" };
            }

            if (end.getTime() === start.getTime()) {
                return { valid: false, message: "Start and end date-time must be different" };
            }
        }
        return { valid: true, message: "" };

    };


    const handleSaveSchedule = () => {

        const toMinutes = (time) => {
            const [h, m] = time.split(":").map(Number);
            return h * 60 + m;
        };

        // time range exist check
        if(templateData){

            var overlap=false;

            for (const item of templateData) {

                const itemStart = toMinutes(item.start_time);
                const itemEnd = toMinutes(item.end_time);

                const startDate = new Date(item.start_date);
                const endDate = new Date(item.end_date);

                const selectedStart = toMinutes(startTime);
                const selectedEnd = toMinutes(endTime);

                const selectedStartDate = new Date(startDateTime);
                const selectedEndDate = new Date(endDateTime);

                const timeOverlap = selectedStart < itemEnd && selectedEnd > itemStart;

                const dateMatch =
                    startDate.getTime() === selectedStartDate.getTime() ||
                    endDate.getTime() === selectedEndDate.getTime();

                const overlap = timeOverlap && dateMatch;
                // alert(overlap)

                console.log(
                    `${item.start_time}-${item.end_time} vs ${startTime}-${endTime} => overlap: ${overlap}`
                );

                if (overlap) {
                    console.log("Overlap found");
                    Swal.fire({
                        icon: "warning",
                        title: ` Time overlap occured.`,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "OK",
                    });
                    return; // stops loop
                }
            }
        }

        if (scheduleType === "non_recurring") {
            if (startDateTime === "" || startTime === "") {
                Swal.fire({
                    title: "!Warning",
                    text: "Please add schedule",
                    confirmButtonColor: "#3085d6",
                })
                return;
            }
        }

        if (scheduleType === "recurring" && recurring_type==="") {
            Swal.fire({
                icon: "warning",
                title: "Please Choose a Recurring Mode",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
            });
            return;
        }


        const validation = isSameDateTime(startDateTime, startTime, endDateTime, endTime);

        if (!validation.valid) {
            Swal.fire({
                title: "Warning",
                text: validation.message,
                confirmButtonColor: "#3085d6",
            });
            return;
        }

        console.log(startTime, "------------", endTime)
        if (startTime === "00:00" || startTime === "0:0" || startTime === "") {
            Swal.fire({
                icon: "error",
                title: "Invalid Start Time",
                text: "Start time cannot be 00:00",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
            });
            return;
        }

        if (endTime < startTime) {
            Swal.fire({
                icon: "error",
                title: "End time should be greater than start time",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
            });
            return;
        }

        if (endTime === startTime) {
            Swal.fire({
                icon: "error",
                title: "Start and end date-time must be different",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
            });
            return;
        }

        if (recurring_type === "day" && days === "") {
            Swal.fire({
                icon: "warning",
                title: "Please Choose a day",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
            });
            return;
        }

        const weekDaysExists = Array.isArray(templateData) &&
            templateData.some(
                item =>
                    item.schedule_mode?.toLowerCase() === "week_days"
            );

        if (weekDaysExists) {
            // if (recurring_type === "week_days") {
            Swal.fire({
                icon: "warning",
                title: "Week Days Schedule Already Exists",
                text: "A week days schedule is already added. Please remove the existing schedule before adding a new one.",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
            });

            return;
            // }
        }
        if (recurring_type === "week_days") {
            setDays("Week_days")
        }
        const DaysExists = Array.isArray(templateData) &&
            templateData.some(
                item =>
                    item.schedule_mode?.toLowerCase() === "day"
            );

        if (DaysExists) {
            if (recurring_type === "week_days") {
                Swal.fire({
                    icon: "warning",
                    title: "Day Schedule Exists",
                    text: "If you want to add week_days schedule. Please remove the existing schedule before adding a new one.",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "OK",
                });

                return;
            }
        }

        const scheduleObj = {
            id: null,
            schedule_type: scheduleType,
            start_date: startDateTime,
            end_date: endDateTime,
            start_time: startTime,
            end_time: endTime,
            schedule_mode: recurring_type,
            recurring_days: days
        };

        setTemplateData(old=>[
            ...old,
            scheduleObj
        ]);

        setStartTime("");
        setEndTime("");
        setStartDateTime("");
        setEndDateTime("");

        // onClose();
    };

    const filteredOptions = schedulelist.filter(option =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
        setShowMenu(true);
    };

    const handleOptionSelect = async(option) => {
        // alert(option.id)
        setSelectedOption(option);
        setSearchTerm(option.name); // Show selected label in input
        setShowMenu(false); // Hide menu after selection
        
        try{
            const res = await axiosprivate.get(`${process.env.REACT_APP_API_URL}/contactcentre/shedule_time_template_schedules/${option.id}`)
            
            if(res.status===200){
                console.log(JSON.stringify(res.data))
                setSchedList(res.data)
                setTemplateData(res.data);
            }

        }catch(error){
            setTemplateData([]);
            Swal.fire(
                'Warning!',
                `${error.response.data?.error || 'Something Went wrong. Try Again.'}`,
                'warning'
            );
        }
        
    };

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    const handleBlur = () => {
        // Delay hiding menu to allow option selection
        setTimeout(() => setShowMenu(false), 150);
    };

    const createShceduleTemplate=async(id)=>{
        // id will be either 0 or id value 0 for creation other for updation

        // const formData = new FormData();formData.append("scheduledTime",JSON.stringify(data.schedule_time));
        const formData = new FormData();
        formData.append("scheduledTime",JSON.stringify(templateData));
        formData.append("sheduled_templates_name",JSON.stringify(searchTerm));
        try{
            const res = await axiosPrivate.post(`${process.env.REACT_APP_API_URL}/contactcentre/shedule_time_template_schedules/${id}`,formData)
            if(res.status===200){
                Swal.fire(
                    `${res?.data?.success.includes('Created')?'Created':'Updated'}!`,
                    // 'Schedule Template has been Created.',
                    `${res?.data?.success}`,
                    'success'
                );
                onClose()
                clearForm()
                fetchScheduleTimeTeamplates();
            }else{
                Swal.fire(
                    'Error!',
                    'Something went wrong',
                    'error'
                );
            }
        }catch(error){
            Swal.fire(
                'Error!',
                `${error.response.data?.error || 'Something went wrong'}`,
                'error'
            );
        }
    }

    const clearForm=()=>{
        setTemplateData([]);
        setSearchTerm('');
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="bg-white rounded-xl shadow-xl w-[75rem] p-6 pr-1">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold">Add Schedule Time Template</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 pr-3"
                    >
                        ✕
                    </button>
                </div>

                {/* overflow start */}
                <div className="overflow-y-auto max-h-[27.5rem]">
                        

                            <div className="flex space-x-5">
                                <div className="relative">
                                    <h1 className="text-md text-slate-400 pt-4">Schedule Template Name</h1>
                                    
                                    {/* Searchable Input */}
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={handleInputChange}
                                        onClick={toggleMenu}
                                        onBlur={handleBlur}
                                        placeholder="Select Schedule Template"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 pl-4 p-2.5 w-[35rem]"
                                    />

                                    {/* Dropdown Menu */}
                                    {showMenu && (
                                        <ul
                                        className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-10"
                                        onMouseDown={(e) => e.preventDefault()} // Prevent input blur when interacting with dropdown
                                        >
                                        {filteredOptions.map((option) => (
                                            <li
                                            key={option.value}
                                            onClick={() => handleOptionSelect(option)} // Handle option selection
                                            className="cursor-pointer py-2 px-4 hover:bg-gray-200"
                                            >
                                            {option.name}
                                            </li>
                                        ))}
                                        {filteredOptions.length === 0 && (
                                            <li className="py-2 px-4 text-gray-500">No options found</li>
                                        )}
                                        </ul>
                                    )}
                                </div>
                                <div>
                                    <h1 className="text-md text-slate-400 pt-4 ml-[-0.3rem]">Schedule Type</h1>
                                    <select
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[20rem] p-2.5 w-[35rem] ml-[-0.3rem]"
                                        value={scheduleType}
                                        onChange={handleScheduleType}
                                    >
                                        <option value={"non_recurring"}>Non Recurring</option>
                                        <option value={"recurring"}>Recurring</option>
                                    </select>
                                </div>
                                
                            </div>

                            <div className="flex space-x-4">
                                {scheduleType === "non_recurring" ?
                                    <div>
                                        <h1 className="text-md text-slate-400 mb-1">Start Date</h1>
                                        <input
                                            type="date"
                                            value={startDateTime}
                                            onChange={(e) => setStartDateTime(e.target.value)}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-[20rem] h-10 p-2.5 w-[35rem]"
                                            min={new Date().toISOString().slice(0, 16)}
                                        />
                                    </div>
                                    : <></>}
                                <div>
                                    <h1 className="text-md text-slate-400 mb-1">Start Time</h1>
                                    <input
                                        type="time"
                                        value={startTime}
                                        onChange={(e) => setStartTime(e.target.value)}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-[20rem] h-10 p-2.5 w-[35rem]"
                                    />
                                </div>

                                {scheduleType === "recurring" ? (
                                    <div>
                                        <h1 className="text-md text-slate-400 pt-1">Recurring Mode</h1>
                                        <select
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5 w-[35rem]"
                                            value={recurring_type}
                                            onChange={handleRecurringMode}
                                        >
                                            <option value="" selected>Select an option</option>
                                            <option value={"week_days"}>Week days</option>
                                            <option value={"day"}>Day</option>
                                        </select>
                                    </div>
                                ) : (<></>)}
                            </div>

                            <div className="flex space-x-4">
                                {scheduleType === "non_recurring" ?
                                    <div>
                                        <h1 className="text-md text-slate-400 mb-1">End Date</h1>
                                        <input
                                            type="date"
                                            value={endDateTime}
                                            onChange={(e) => setEndDateTime(e.target.value)}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-[20rem] h-10 p-2.5 w-[35rem]"
                                            min={new Date().toISOString().slice(0, 16)}
                                        />
                                    </div>
                                    : <></>}
                                <div>
                                    <h1 className="text-md text-slate-400 mb-1">End Time</h1>
                                    <input
                                        type="time"
                                        value={endTime}
                                        onChange={(e) => setEndTime(e.target.value)}
                                        className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-[20rem] h-10 p-2.5 ${recurring_type === "day" ? 'w-[35rem]': 'w-[29.5rem]'}`}
                                        min={new Date().toISOString().slice(0, 16)}
                                    />
                                </div>

                                {recurring_type === "day" && scheduleType === "recurring" ? (
                                    <div>
                                        <h1 className="text-md text-slate-400 pt-1">Recurring Days</h1>
                                        <select
                                            className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5 ${recurring_type === "day" && scheduleType === "recurring" ? 'w-[29.5rem]' : 'w-[35rem]'}`}
                                            value={days}
                                            onChange={handleDays}
                                        >
                                            <option value={""}>Select days</option>
                                            <option value={"mon"}>Mon</option>
                                            <option value={"tue"}>Tue</option>
                                            <option value={"wed"}>Wed</option>
                                            <option value={"thu"}>Thu</option>
                                            <option value={"fri"}>Fri</option>
                                        </select>
                                    </div>
                                ) : (<></>)}

                                <div className="flex items-end">
                                    <button
                                        onClick={handleSaveSchedule}
                                        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold h-10 px-6 rounded-lg"
                                    >
                                        Add
                                    </button>
                                </div>
                                
                            </div>
                        
                            <div className="mt-9">
                                <div className="flex justify-between mb-1">
                                    <h3 className="font-bold pl-[0.75rem]">Schedule List</h3>
                                    <button onClick={()=>setTemplateData([])} className="px-[0.5rem] py-[0.1rem] text-sm bg-red-600 text-white rounded-md hover:bg-red-700 transition mr-[1.7rem]"><small>Clear</small></button>
                                </div>

                                    <table className="min-w-full text-sm text-left">
                                        <thead className="border-b rounded" style={{backgroundColor:"#00000009"}}>
                                            <tr>
                                                <th className="pe-6 pl-3 py-4 font-medium text-gray-700">Schedule Type</th>
                                                <th className="px-6 py-4 font-medium text-gray-700">Start Date</th>
                                                <th className="px-6 py-4 font-medium text-gray-700">Start Time</th>
                                                <th className="px-6 py-4 font-medium text-gray-700">End Date</th>
                                                <th className="px-6 py-4 font-medium text-gray-700">End Time</th>
                                                <th className="px-6 py-4 font-medium text-gray-700">Days</th>
                                                <th className="ps-6 pr-3 py-4 font-medium text-gray-700">Action</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div className="relative overflow-x-hidden mt-0 max-h-[22rem]">

                                            <table className="min-w-full text-sm text-left ">
                                                <tbody>
                                                {templateData.map((obj, index) => (
                                                    <tr key={obj.id ?? `temp-${index}`} className="border-b hover:bg-gray-50 transition-colors">
                                                    <td className="px-6 pl-3 py-3 text-gray-700 font-mono w-[17%]">
                                                        {obj.schedule_type}
                                                    </td>
                                                    <td className="px-6 py-3 text-gray-700 font-mono  w-[16%]">
                                                        {obj.start_date}
                                                    </td>
                                                    <td className="px-6 py-3 text-gray-700 font-mono  w-[15.5%]">
                                                        {new Date(`1970-01-01T${obj.start_time}`).toLocaleTimeString("en-US", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                        })}
                                                    </td>
                                                    <td className="px-6 py-3 text-gray-700 font-mono  w-[15%]">
                                                        {obj.end_date}
                                                    </td>
                                                    <td className={`px-6 py-3 text-gray-700 font-mono ${obj.end_time? obj.end_date? 'w-[18.5%]' : 'w-[15%] ': 'w-[14.8%] ' }`}>
                                                        {new Date(`1970-01-01T${obj.end_time}`).toLocaleTimeString("en-US", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                        })}
                                                    </td>
                                                    <td className="px-6 py-3 text-gray-700 font-mono ">
                                                        {obj.recurring_days}
                                                    </td>
                                                    <td className="px-6 pr-3 py-3 flex space-x-2">
                                                        <button
                                                        onClick={() => handleDelete(index, obj.id)}
                                                        className="inline-flex items-center justify-center w-8 h-8 rounded-full text-red-500 hover:bg-red-50 hover:text-red-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-200"
                                                        aria-label={`Delete schedule ${obj}`}
                                                        title="Delete schedule"
                                                        >
                                                            <Trash2 
                                                                className="text-red-600 w-4 h-4 transition-transform group-hover:scale-110" 
                                                                strokeWidth={2}
                                                            />
                                                        </button>
                                                    </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                    </div>
                            </div>

                            {/* <hr className="mt-5"></hr> */}

                </div>
                {/* overflow end */}

    
                <div className="flex space-x-4 mt-5">

                    <div className="w-[24rem]"></div>

                    <div className="">
                        <button
                            onClick={()=>createShceduleTemplate(0)}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold h-10 px-6 rounded-lg mr-5"
                        >
                            Create
                        </button>

                        <button
                            onClick={()=>createShceduleTemplate(1)}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold h-10 px-6 rounded-lg mr-5"
                        >
                            Update
                        </button>

                        <button
                            onClick={onClose}
                            className="bg-red-600 hover:bg-red-700 text-white font-semibold h-10 px-6 rounded-lg"
                        >
                            Cancel
                        </button>
                    </div>
                </div>



            </div>
        </div>
    );
};

export default ScheduleTemplatePopup;